import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/features/auth'
import { SuperAdminAdminsPage } from './page'

export const Route = createFileRoute('/_authenticated/super-admin/admins/')({
  beforeLoad: () => {
    const { auth } = useAuthStore.getState()
    if (auth.user?.role !== 'super_admin') {
      throw redirect({ to: '/403' })
    }
  },
  component: SuperAdminAdminsPage,
})
